import { NavLink } from "react-router-dom";

/**
 * v2 bottom nav - a floating pill, inset from the screen edges, with
 * backdrop blur and a soft float shadow. The active tab gets a filled
 * accent chip; inactive tabs are muted glyph + label.
 */
/* Eén tab-lijst voor beide navigaties (mobiele pill + desktop-rail),
   zodat een nieuwe route maar op één plek hoeft te landen. */
export const NAV_ITEMS = [
  { to: "/",         label: "Overzicht", Icon: GridIcon },
  { to: "/history",  label: "Historie",  Icon: ChartIcon },
  { to: "/live",     label: "Live",      Icon: BoltIcon },
  { to: "/prijzen",  label: "Prijzen",   Icon: EuroIcon },
  { to: "/prognose", label: "Prognose",  Icon: TrendIcon },
  { to: "/account",  label: "Account",   Icon: UserIcon },
] as const;

export function TabBar() {
  return (
    <nav className="fixed bottom-0 inset-x-0 z-50 pb-safe pointer-events-none lg:hidden">
      <div className="max-w-md mx-auto px-4">
        <div
          className="pointer-events-auto flex items-stretch justify-between rounded-[1.75rem] border border-card-border shadow-float px-1.5 py-1.5 backdrop-blur-xl"
          style={{ background: "color-mix(in srgb, var(--color-card) 82%, transparent)" }}
        >
          {NAV_ITEMS.map(({ to, label, Icon }) => (
            <Tab key={to} to={to} label={label} icon={<Icon />} />
          ))}
        </div>
      </div>
    </nav>
  );
}

interface TabProps {
  to: string;
  label: string;
  icon: React.ReactNode;
}

function Tab({ to, label, icon }: TabProps) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `pressable flex flex-col items-center justify-center gap-0.5 flex-1 rounded-3xl py-1.5 text-[10px] font-semibold transition-colors ${
          isActive
            ? "bg-accent-soft text-accent"
            : "text-ink-mute hover:text-ink"
        }`
      }
    >
      {icon}
      {label}
    </NavLink>
  );
}

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

function GridIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
    </svg>
  );
}
function ChartIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <path d="M3 17l6-6 4 4 8-8" />
    </svg>
  );
}
function BoltIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
    </svg>
  );
}
function UserIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c1.5-4 5-6 8-6s6.5 2 8 6" />
    </svg>
  );
}
function TrendIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <path d="M3 17l5-8 4 5 4-9 5 12" />
    </svg>
  );
}
function EuroIcon() {
  return (
    <svg width={21} height={21} viewBox="0 0 24 24" {...stroke}>
      <path d="M18 7a7 7 0 100 10" />
      <path d="M4 10h9" />
      <path d="M4 14h9" />
    </svg>
  );
}
